import React from 'react';
import {
  Button,
  Dropdown,
  Confirm,
  Form,
  Header,
  Icon,
  Tab,
  Message,
  Dimmer,
  Loader,
  Checkbox,
  Image,
} from 'semantic-ui-react';
import { inlineStyle } from '../../styles/custom';
import FileUploadButton from '../fileUploadButton';
import PermissionsManager from '../PermissionsManager';

const renderCategories = (categories) => {
  let _categories = [{ value: null, text: '--' }];
  categories.forEach((category) => {
    const categoryWithFrenchLabel = category.details.find(
      (detail) => detail.language_id === 1,
    );
    _categories.push({
      value: category.id,
      text: categoryWithFrenchLabel.label,
    });
  });
  return _categories;
};

const renderPanes = (languages, obj, onChange) => {
  languages;
  return languages.map((language) => {
    return {
      menuItem: language.language,
      render: () => (
        <Tab.Pane key={language.code}>
          <Form.Field>
            <label>Nom de la catégorie</label>
            <Form.Input
              placeholder="Catégorie"
              id="label"
              value={obj.translations[language.id].label || ''}
              onChange={(e) => onChange(e, language.id)}
            />
          </Form.Field>
          {obj.show_on_homepage && (
            <React.Fragment>
              <Form.Field>
                <label>Titre de la catégorie (page d'accueil)</label>
                <Form.Input
                  placeholder="Titre"
                  id="title"
                  value={obj.translations[language.id].title || ''}
                  onChange={(e) => onChange(e, language.id)}
                />
              </Form.Field>
              <Form.Field>
                <label>Description de la catégorie (page d'accueil)</label>
                <Form.Input
                  placeholder="Description"
                  id="description"
                  value={obj.translations[language.id].description || ''}
                  onChange={(e) => onChange(e, language.id)}
                />
              </Form.Field>
              <Form.Field>
                <label>URL cible de la catégorie (page d'accueil)</label>
                <Form.Input
                  placeholder="URL"
                  id="url"
                  value={obj.translations[language.id].url || ''}
                  onChange={(e) => onChange(e, language.id)}
                />
              </Form.Field>
            </React.Fragment>
          )}
        </Tab.Pane>
      ),
    };
  });
};

const CategoryForm = ({
  obj,
  languages,
  categories,
  status,
  onChange,
  onSubmit,
  onDelete,
}) => {
  if (status.loading)
    return (
      <Dimmer active inverted>
        <Loader inverted>Chargement</Loader>
      </Dimmer>
    );

  return (
    <Form>
      <Header>Catégories{status.isNew ? ' : Création' : ' : Édition'}</Header>
      {status.error ? (
        <Message negative>
          <Message.Header>Erreur</Message.Header>
          <p>{status.message}</p>
        </Message>
      ) : null}
      {!status.error && status.message ? (
        <Message info>
          <p>{status.message}</p>
        </Message>
      ) : null}
      <Form.Field>
        <label>Catégorie parente (optionnel)</label>
        {categories.loading ? (
          <div>Chargement des catégories</div>
        ) : (
          <Dropdown
            fluid
            selection
            closeOnChange
            id="parent_id"
            placeholder="Sélectionnez une catégorie parente"
            value={obj.parent_id}
            options={renderCategories(categories.getCategories)}
            onChange={(param, data) => onChange(param, data, 'dropdown')}
          />
        )}
      </Form.Field>
      <Form.Field>
        <label>Afficher sur la page d'accueil (optionnel)</label>
        <Checkbox
          id="show_on_homepage"
          label="Afficher sur la page d'accueil (carousel)"
          checked={obj.show_on_homepage || false}
          onChange={(e, data) => onChange(e, data, 'checkbox')}
        />
      </Form.Field>
      {languages.loading || !obj ? (
        <div>Chargement</div>
      ) : (
        <Tab panes={renderPanes(languages.getLanguages, obj, onChange)} />
      )}

      {obj.show_on_homepage && (
        <React.Fragment>
          <br />
          <Form.Field>
            {typeof obj.image === 'string' ? (
              <Image src={obj.image} size="large" />
            ) : null}
            <FileUploadButton id="image" label="Image" onChange={onChange} />
          </Form.Field>
        </React.Fragment>
      )}

      <br />

      <PermissionsManager
        hasPermissions={['create_category', 'update_category']}
      >
        {status.loading ? (
          <Button type="submit" color="olive" loading></Button>
        ) : (
          <Button type="submit" color="olive" floated="left" onClick={onSubmit}>
            <Icon name="save" /> Sauvegarder
          </Button>
        )}
      </PermissionsManager>
      {!status.isNew ? (
        <div>
          <PermissionsManager hasPermissions={['delete_category']}>
            <Button
              type="submit"
              color="red"
              floated="right"
              onClick={(event, data) => {
                onDelete(event, { confirm: true });
              }}
            >
              <Icon name="delete" /> Suppression
            </Button>
          </PermissionsManager>
        </div>
      ) : null}
      <Confirm
        content="Êtes-vous sûr(e) de vouloir supprimer cette catégorie ? Cette action est définitive."
        open={status.deletion.confirm}
        onCancel={(event, data) => {
          onDelete(event, { confirm: null });
        }}
        onConfirm={(event, data) => {
          onDelete(event, { confirm: false });
        }}
        style={inlineStyle.modal}
      />
    </Form>
  );
};

export default CategoryForm;



// WEBPACK FOOTER //
// ./src/components/form/Category.js